<template>
  <li
    class="track-item track-map-list-item"
    :class="{ active, 'track-map-list-item--hidden': !visible }"
    @click="$emit('select', track.id)"
  >
    <label class="track-map-list-item__checkbox" @click.stop>
      <input
        type="checkbox"
        :checked="visible"
        :aria-label="`Показать ${track.name} на карте`"
        @change="$emit('toggle-visibility', track.id)"
      />
    </label>

    <div class="track-map-list-item__content">
      <RouterLink
        class="track-map-list-item__title"
        :to="{ name: 'track', params: { id: track.id } }"
        @click.stop
      >
        {{ track.name }}
      </RouterLink>

      <div class="track-item-meta track-map-list-item__meta">
        {{ formatDistance(track.distance_m) }} · {{ formatDuration(track.duration_s) }}
      </div>
    </div>
  </li>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { formatDistance, formatDuration } from '../utils/trackFormat'

defineProps({
  track: {
    type: Object,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  visible: {
    type: Boolean,
    default: true,
  },
})

defineEmits(['select', 'toggle-visibility'])
</script>

<style scoped>
.track-map-list-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.track-map-list-item__checkbox {
  display: inline-flex;
  flex-shrink: 0;
  padding-top: 0.125rem;
  cursor: pointer;
}

.track-map-list-item__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
}

.track-map-list-item__title {
  color: #0f172a;
  font-weight: 600;
  text-decoration: none;
  line-height: 1.25;
}

.track-map-list-item__title:hover {
  text-decoration: underline;
}

.track-map-list-item__meta {
  margin-top: 0;
}
</style>
